/**
 * @prettier
 * @author Alexander Nagelberg
 *
 **/

export const refundStatuses = {
  APPROVED: 'Approved',
  LETTER_PENDING: 'Letter Pending',
  PAYMENT_PENDING: 'Payment Pending',
  PAYMENT_FAILED: 'Failed Payment',
  FAILED_VALIDATION: 'Failed Validation',
  PAID: 'Paid',
  PAID_BY_VOUCHER: 'Paid by Voucher',
  SENT_TO_FAS: 'Sent to FAS',
  STOP_PAYMENT: 'Stop Payment',
  FAILED_PRESCREEN: 'Failed Pre-Screen',
  QUEUED_FOR_PAYMENT: 'Queued for Payment'
}

export const failureTypes = {
  NO_VETERAN_RECORD_EXISTS: '(Validation) Veteran not found',
  NO_ADDRESS: '(Validation) No address found',
  BAD_ADDRESS: '(Validation) Bad address format',
  INCORRECT_REFUND_AMOUNT: '(Validation) Incorrect refund amount',
  VETERAN_DECEASED: '(Validation) Veteran is deceased',
  FAS_VETERAN_NOT_FOUND: "(FAS) Couldn't find veteran",
  FAS_VETERAN_NOT_ENTITLED: "(FAS) Couldn't verify entitlements",
  FAS_VETERAN_DECEASED: '(FAS) Veteran is deceased'
}

export const URLs = {
  FUNDING_FEE_REFUND_PATH: '/lgyhub/api/funding-fee/refunds',
  FUNDING_FEE_REFUND_APP_PATH: '/lgyhub/funding-fee/refunds',
  WEBLGY_PATH: '/lgyhub/WebLGY',
  GET_REFUND_PATH: '',
  UPDATE_REFUND_PATH: '',
  SEARCH_PATH: 'search',
  REFUND_TOTALS_PATH: 'totals',
  NOTE_PATH: 'note',
  REFUND_VALIDATION_PARAM: 'validate'
}

export const fullURL = (path, param) => `${URLs.FUNDING_FEE_REFUND_PATH}/${path}` + (param ? `/${param}` : '')
